import React from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ArchitectureOutlinedIcon from '@mui/icons-material/ArchitectureOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CodeOffOutlinedIcon from '@mui/icons-material/CodeOffOutlined';
import training from '../assets/images/training1.png';

function CourseStats() {
  return (
    <div
      className='w-full h-auto bg-no-repeat object-cover '
      style={{
        backgroundImage: `url(${training})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <div className='flex justify-center items-center flex-wrap h-[auto] w-full bg-[rgb(9,20,45,0.6)]'>
        <div className='w-full h-auto sm:h-[78px] bg-[#041a45] text-[16px] leading-[24px] text-start px-[32px]'>
          <p
            className='w-full h-auto sm:w-[1148px] sm:h-[38px] sm:text-[25.6px] sm:leading-[38.4px] text-start text-white py-[20px] px-[12px] sm:px-[66px]'
            data-aos='fade-up-left'
          >
            {' '}
            Explore in-demand roles - and the skills you'll need to succeed in
            them.
          </p>
        </div>
        <div className='w-[348px] h-[550px] py-[16px] px-[7px] m-[16px] bg-[rgba(0,0,0,0.4)] shadow-[rgba(0, 0, 0, 0.1) 0px 0px 20px 0px] rounded-[30px]'>
          <div className='w-[316px] h-[251px] text-white'>
            <div className='w-[284px] h-[auto] m-[16px] text-[80px] leading-[80px] text-left'>
              <AccountCircleOutlinedIcon
                className='text-white'
                sx={{ fontSize: 110 }}
              />
            </div>
            <p className='mx-[16px] p-[10px] text-[16px] leading-[24px] text-start rounded-[4px] text-white'>
              9{' '}
              <span className='text-white text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                courses{' '}
              </span>{' '}
              -{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                12 hours of content
              </span>{' '}
            </p>
            <p className='w-[284px]  h-[76px] text-[25.6px] m-[16px] mb-[30px] leading-[38.4px] text-left text-[white] font-bold'>
              Administrative professional
            </p>
          </div>
          <div className='w-[380px] h-[543px] m-[8px] py-[12px] px-[4px] rounded-[30px]'>
            <p className='w-[284px] h-[auto] text-[17.6px] leading-[26.4px] text-left p-[22px] bg-[rgb(255,239,211)] rounded-[30px]'>
              Develop essential skills needed for administrative roles,
              including communication, writing, time management, and must-have
              software skills.
            </p>
          </div>
        </div>

        {/*  */}
        <div className='w-[348px] h-[550px] py-[16px] px-[7px] m-[16px] bg-[rgba(0,0,0,0.4)] shadow-[rgba(0, 0, 0, 0.1) 0px 0px 20px 0px] rounded-[30px]'>
          <div className='w-[316px] h-[251px]'>
            <div className='w-[284px] h-[auto] m-[16px] text-[80px] leading-[80px] text-left'>
              <ArchitectureOutlinedIcon
                className='text-white'
                sx={{ fontSize: 110 }}
              />
            </div>

            <p className='mx-[16px] p-[10px] text-[16px] leading-[24px] text-start rounded-[4px] text-[white]'>
              9{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                courses{' '}
              </span>{' '}
              -{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                12 hours of content
              </span>{' '}
            </p>
            <p className='w-[284px]  h-[76px] text-[25.6px] m-[16px] leading-[38.4px] text-left text-[white] font-bold'>
              Project Manager
            </p>
          </div>
          <div className='w-[380px] h-[543px] m-[8px] py-[12px] px-[4px] rounded-[30px]'>
            <p className='w-[284px] h-[auto] text-[17.6px] leading-[26.4px] text-left p-[22px] bg-[rgb(255,239,211)] rounded-[30px]'>
              Discover how to manage projects effectively with scheduling,
              budgeting, and communication, and explore PM tools in Microsoft
              365.
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[348px] h-[550px] py-[16px] px-[7px] m-[16px] bg-[rgba(0,0,0,0.4)] shadow-[rgba(0, 0, 0, 0.1) 0px 0px 20px 0px] rounded-[30px]'>
          <div className='w-[316px] h-[251px]'>
            <div className='w-[284px] h-[auto] m-[16px] text-[80px] leading-[80px] text-left'>
              <StorageOutlinedIcon
                className='text-white'
                sx={{ fontSize: 110 }}
              />
            </div>
            <p className='mx-[16px] p-[10px] text-[16px] leading-[24px] text-start rounded-[4px] text-[white]'>
              9{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                courses{' '}
              </span>{' '}
              -{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                12 hours of content
              </span>{' '}
            </p>
            <p className='w-[284px]  h-[76px] text-[25.6px] m-[16px] leading-[38.4px] text-left text-[white] font-bold'>
              Business analyst
            </p>
          </div>
          <div className='w-[380px] h-[543px] m-[8px] py-[12px] px-[4px] rounded-[30px]'>
            <p className='w-[284px] h-[auto] text-[17.6px] leading-[26.4px] text-left p-[22px] bg-[rgb(255,239,211)] rounded-[30px]'>
              Explore foundational business analysis concepts and understand key
              processes. Practice using software tools for common business
              analysis tasks.  
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[348px] h-[550px] py-[16px] px-[7px] m-[16px] bg-[rgba(0,0,0,0.4)] shadow-[rgba(0, 0, 0, 0.1) 0px 0px 20px 0px] rounded-[30px]'>
          <div className='w-[316px] h-[251px]'>
            <div className='w-[284px] h-[auto] m-[16px] text-[80px] leading-[80px] text-left'>
              <AdminPanelSettingsOutlinedIcon
                className='text-white'
                sx={{ fontSize: 110 }}
              />
            </div>
            <p className='mx-[16px] p-[10px] text-[16px] leading-[24px] text-start rounded-[4px] text-[white]'>
              9{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                courses{' '}
              </span>{' '}
              -{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                12 hours of content
              </span>{' '}
            </p>
            <p className='w-[284px]  h-[76px] text-[25.6px] m-[16px] leading-[38.4px] text-left text-[white] font-bold'>
              Systems administrator
            </p>
          </div>
          <div className='w-[380px] h-[543px] m-[8px] py-[12px] px-[4px] rounded-[30px]'>
            <p className='w-[284px] h-[auto] text-[17.6px] leading-[26.4px] text-left p-[22px] bg-[rgb(255,239,211)] rounded-[30px]'>
              Learn about this multifaceted role — from managing on-site, cloud,
              physical, and virtual implementations, as well as storage
              security.
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[348px] h-[550px] py-[16px] px-[7px] m-[16px] bg-[rgba(0,0,0,0.4)] shadow-[rgba(0, 0, 0, 0.1) 0px 0px 20px 0px] rounded-[30px]'>
          <div className='w-[316px] h-[251px]'>
            <div className='w-[284px] h-[auto] m-[16px] text-[80px] leading-[80px] text-left'>
              <BarChartOutlinedIcon
                className='text-white'
                sx={{ fontSize: 110 }}
              />
            </div>
            <p className='mx-[16px] p-[10px] text-[16px] leading-[24px] text-start rounded-[4px] text-[white]'>
              9{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                courses{' '}
              </span>{' '}
              -{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                12 hours of content
              </span>{' '}
            </p>
            <p className='w-[284px]  h-[76px] text-[25.6px] m-[16px] leading-[38.4px] text-left text-[white] font-bold'>
              Data analyst
            </p>
          </div>
          <div className='w-[380px] h-[543px] m-[8px] py-[12px] px-[4px] rounded-[30px]'>
            <p className='w-[284px] h-[auto] text-[17.6px] leading-[26.4px] text-left p-[22px] bg-[rgb(255,239,211)] rounded-[30px]'>
              Explore foundational concepts used in data analysis and practice
              using software tools for data analytics and data visualization. 
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[348px] h-[550px] py-[16px] px-[7px] m-[16px] bg-[rgba(0,0,0,0.4)] shadow-[rgba(0, 0, 0, 0.1) 0px 0px 20px 0px] rounded-[30px]'>
          <div className='w-[316px] h-[251px]'>
            <div className='w-[284px] h-[auto] m-[16px] text-[80px] leading-[80px] text-left'>
              <CodeOffOutlinedIcon
                className='text-white'
                sx={{ fontSize: 110, fontWeight: 2 }}
              />
            </div>
            <p className='mx-[16px] p-[10px] text-[16px] leading-[24px] text-start rounded-[4px] text-[white]'>
              9{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                courses{' '}
              </span>{' '}
              -{' '}
              <span className='text-[white] text-[17.6px] leading-[26.4px] text-left font-bold'>
                {' '}
                12 hours of content
              </span>{' '}
            </p>
            <p className='w-[284px]  h-[76px] text-[25.6px] m-[16px] leading-[38.4px] text-left text-[white] font-bold'>
              Software Developer
            </p>
          </div>
          <div className='w-[380px] h-[543px] m-[8px] py-[12px] px-[4px] rounded-[30px]'>
            <p className='w-[284px] h-[auto] text-[17.6px] leading-[26.4px] text-left p-[22px] bg-[rgb(255,239,211)] rounded-[30px]'>
              Understand the core concepts and structure of programming
              languages and learn how they’re applied.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CourseStats;
